import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    changeDisplayedUsers, changeUsersListSettings, usersPageShift, requestGetUsers,
    toggleModal, toggleConfirmDialog, changeUserListStoreSettings
} from "../actions/usersList";
import UsersList from '../components/usersList';
import { push } from 'connected-react-router'
import _ from 'lodash';
import {requestEditUser} from "../actions/newUser";

class AgentsListHOC extends Component {


	componentWillMount() {
		this.props.getUsers(this.props.user.loggedInUser.token)//TODO: remove token! not needed
		// this.props.changeUsersListSettings('suggestions', this.props.usersList.allUsers);
	}

    //function that handles all rows select
    _handleAllRowsSelect = (checked) => {
		let displayed = this.calculateFeatured()[0];

		let selectedRows = {};
		if (checked) {
			displayed.forEach((e, index) => {
				selectedRows = { ...selectedRows, [index]: e };
			});
		}

		this.props.changeUserListStoreSettings({
			key: 'selectedAragUsers',
			value: selectedRows
		});
    };

    _handleRowSelect = (checked, rowIndex, row) => {
		let currentSelectedRows = {};
		if (checked) {
			currentSelectedRows = { ...this.props.usersList.selectedAragUsers, [rowIndex]: row }

		} else {
			currentSelectedRows = _.omit(this.props.usersList.selectedAragUsers, [rowIndex]);
		}

		this.props.changeUserListStoreSettings({
			key: 'selectedAragUsers',
			value: currentSelectedRows
		});
    };

    //function that returns true if the row is checked
    _isRowChecked = (key) => {
        return this.props.usersList.selectedAragUsers.hasOwnProperty(key);
    };

	// function called when user tries to log in with submit button
	//action will be called to talk to the api
	HandleUserLoginFormSubmit = (evt) => {
		evt.preventDefault();
		this.props.logIn(this.props.user.loginFormData);
	};


	//helper function that takes all of the solicitor user and returns some of them
	//to be displayed in the solicitorList component based on the settings selected
	usersPerPage = (users) => {
		let displayAmount = this.props.usersList.usersListSettings.displayAmount;
		let totalBoxes = users.length;
		let page = this.props.usersList.usersListSettings.page;
		let start = (page - 1) * displayAmount;
		let end = start + displayAmount;

		return users.slice(start, end)
	};

	handleRowSelect = (evt, user) => {
        if(evt.button === 1){
            window.open('/users/edit-user/' + user.id, '_blank');
        } else {
            this.props.push('/users/edit-user/'+ user.id);
        }
	};


	calculateFeatured = () => {
		let users = this.props.usersList.allUsers;
		let suggestions = this.props.usersList.usersListSettings.selectedSuggestions;
		let page = this.props.usersList.usersListSettings.page;
		let selectedView = parseInt(this.props.usersList.usersListSettings.displayAmount);
		let featured = [];
		featured = this.props.usersList.allUsers;
		if (suggestions) {  //display suggestions
			if(suggestions.length > 0)
				featured = suggestions;
		}
		//calculation of the applications per page
		let start = (page - 1) * selectedView;
		let end = start + selectedView;
		let featuredPerPage = featured.slice(start, end);
		return [featuredPerPage, featured.length];
	};

	// Teach Autosuggest how to calculate suggestions for any given input value.
	getSuggestions = value => {
		const inputValue = value.trim().toLowerCase();
		const inputLength = inputValue.length;

		return inputLength === 0 ? [] : this.props.usersList.allUsers.filter(app =>
			(app.username?app.username.toLowerCase().includes(inputValue): false) ||
			(app.forename?app.forename.toLowerCase().includes(inputValue): false)||
			(app.surname?app.surname.toLowerCase().includes(inputValue): false) ||
			(app.email?app.email.toLowerCase().includes(inputValue): false)
		);
	};

	getSuggestionValue = suggestion => suggestion.username;

	renderSuggestion = suggestion => (
		<div>
			{suggestion.username}
		</div>
	);

	onChange = (event, {newValue}) => {
		event.preventDefault()
		this.props.changeUsersListSettings('value', newValue)
		if (newValue === '') {
			this.props.changeUsersListSettings('selectedSuggestions', this.props.usersList.allUsers);
		}
	};

	onSuggestionsFetchRequested = ({value}) => {
		this.props.changeUsersListSettings('suggestions', this.getSuggestions(value))
	};

	onSuggestionsClearRequested = () => {
		if (this.props.usersList.usersListSettings.value === '') {
			this.props.changeUsersListSettings('suggestions', []);
		}
	};

	onAppSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
		if (method === 'click' || (method === 'enter')) {
			this.props.changeUsersListSettings('suggestions', [suggestion]);
			this.props.changeUsersListSettings('selectedSuggestions', [suggestion]);
		}
	};

	handleAutosuggestButton = () => {
		let suggestions = this.props.usersList.usersListSettings.suggestions;
		this.props.changeUsersListSettings('selectedSuggestions', suggestions)
	};

	_applyAction = () => {
		if(!this.props.usersList.usersListSettings.selectedAction) return false;
		_.map(this.props.usersList.selectedAragUsers, user => {
			this.props.requestEditUser({
				id: user.id,
				disabled: this.props.usersList.usersListSettings.selectedAction === 'disable' ?
					true : (
                        this.props.usersList.usersListSettings.selectedAction === 'enable'?false: user.disabled
					)
			})
		})
	};

	render() {
		let value = this.props.usersList.usersListSettings.value;
		const inputProps = {
			placeholder: '',
			value,
			onChange: this.onChange
		};
		return (
			<UsersList
                _applyAction={this._applyAction}
				_handleAllRowsSelect={this._handleAllRowsSelect}
				_handleRowSelect={this._handleRowSelect}
				_isRowChecked={this._isRowChecked}
				user={this.props.user}
				pageIndexCalculator={this.pageIndexCalculator}
				usersList={this.props.usersList}
				usersPagination={this.props.usersPagination}
				usersPerPage={this.usersPerPage}
				usersDisplaySetting={this.props.usersDisplaySetting}
				updateDisplayedUsers={this.props.updateDisplayedUsers}
				handleRowSelect = {this.handleRowSelect}
				calculateFeatured = {this.calculateFeatured}
				handleInputChange={this.props.changeUsersListSettings}
				handleAutosuggestButton={this.handleAutosuggestButton}
				onSuggestionSelected={this.onAppSuggestionSelected}
				suggestions={this.props.usersList.usersListSettings.suggestions}
				inputProps = {inputProps}
				getSuggestionValue={this.getSuggestionValue}
				renderSuggestion={this.renderSuggestion}
				onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
				onSuggestionsClearRequested={this.onSuggestionsClearRequested}
			/>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		usersList: state.usersList,
		user: state.user
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateDisplayedUsers: (data) => {
		dispatch(changeDisplayedUsers(data))
		},
		usersDisplaySetting: (settingKey, value) => {
			dispatch(changeUsersListSettings(settingKey, value))
		},
		usersPagination: (direction) => {
			dispatch(usersPageShift(direction))
		},
		push: (path) => {
			dispatch(push(path))
		},
		changeUsersListSettings: (key, value) => {
			dispatch(changeUsersListSettings(key, value))
		},
		getUsers: (token) => {
			dispatch(requestGetUsers(token))
		},
		displayModal: () => {
			dispatch(toggleModal())
		},
		displayConfirm: () => {
			dispatch(toggleConfirmDialog())
		},
        changeUserListStoreSettings: (payload) => {
			dispatch(changeUserListStoreSettings(payload))
		},
        requestEditUser: (user) => {
            dispatch(requestEditUser(user))
        },
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentsListHOC);
